import axios from 'axios';
import { setHeader } from './services_general.js';

export function uploadFileS3(file, name) {
  const formData = new FormData();
  formData.append('file', file.target.files[0]);
  if (name) {
    formData.append('name', name);
  }

  const headers = setHeader();
  // Remove Content-Type para o browser definir automaticamente com boundary para FormData
  delete headers['Content-Type'];

  return axios
    .post(process.env.REACT_APP_API_URL + 'api/upload', formData, {
      headers: headers,
    })
    .then(response => {
      if (response.data && response.data.success) {
        return {
          location: response.data.location,
          key: response.data.key,
        };
      }
      return undefined;
    })
    .catch(err => {
      console.error('Erro ao fazer upload:', err);
      if (err.response && err.response.data) {
        console.error('Detalhes do erro:', err.response.data);
        if (err.response.data.error_details) {
          console.error('Erro detalhado do S3:', err.response.data.error_details);
        }
      }
      return undefined;
    });
}

export function uploadImageS3(file) {
  const formData = new FormData();
  formData.append('file', file.target.files[0]);
  formData.append('is_image', 'true');

  const headers = setHeader();
  // Remove Content-Type para o browser definir automaticamente com boundary para FormData
  delete headers['Content-Type'];

  return axios
    .post(process.env.REACT_APP_API_URL + 'api/upload/image', formData, {
      headers: headers,
    })
    .then(response => {
      if (response.data && response.data.success) {
        return {
          location: response.data.location,
          key: response.data.key,
        };
      }
      return undefined;
    })
    .catch(err => {
      console.error('Erro ao fazer upload de imagem:', err);
      if (err.response && err.response.data) {
        console.error('Detalhes do erro:', err.response.data);
        if (err.response.data.error_details) {
          console.error('Erro detalhado do S3:', err.response.data.error_details);
        }
      }
      return undefined;
    });
}
